import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BudgetFilters = ({ selectedFilters, onFilterChange }) => {
  const departmentOptions = [
    { value: 'all', label: 'All Departments' },
    { value: 'sales', label: 'Sales' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'it', label: 'IT' },
    { value: 'hr', label: 'Human Resources' },
    { value: 'finance', label: 'Finance' },
    { value: 'operations', label: 'Operations' },
    { value: 'rd', label: 'R&D' }
  ];

  const timePeriodOptions = [
    { value: '2025', label: '2025' },
    { value: '2024', label: '2024' },
    { value: '2023', label: '2023' },
    { value: 'q4_2025', label: 'Q4 2025' },
    { value: 'q3_2025', label: 'Q3 2025' },
    { value: 'q2_2025', label: 'Q2 2025' },
    { value: 'q1_2025', label: 'Q1 2025' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'marketing_campaigns', label: 'Marketing Campaigns' },
    { value: 'infrastructure', label: 'Infrastructure' },
    { value: 'training_development', label: 'Training & Development' },
    { value: 'equipment_supplies', label: 'Equipment & Supplies' },
    { value: 'professional_services', label: 'Professional Services' },
    { value: 'research_projects', label: 'Research Projects' },
    { value: 'travel_expenses', label: 'Travel & Expenses' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'on_track', label: 'On Track' },
    { value: 'over_budget', label: 'Over Budget' },
    { value: 'under_utilized', label: 'Under Utilized' },
    { value: 'approaching_limit', label: 'Approaching Limit' },
    { value: 'pending_approval', label: 'Pending Approval' }
  ];

  const handleFilterChange = (filterType, value) => {
    onFilterChange({ [filterType]: value });
  };

  const handleClearFilters = () => {
    onFilterChange({
      department: 'all',
      timePeriod: '2025',
      category: 'all',
      status: 'all'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 card-shadow">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Budget Filters</h3>
        </div>

        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-muted-foreground">Department:</label>
            <Select
              options={departmentOptions}
              value={selectedFilters?.department}
              onChange={(value) => handleFilterChange('department', value)}
              placeholder="Select Department"
              className="min-w-[150px]"
            />
          </div>

          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-muted-foreground">Time Period:</label>
            <Select
              options={timePeriodOptions}
              value={selectedFilters?.timePeriod}
              onChange={(value) => handleFilterChange('timePeriod', value)}
              placeholder="Select Period"
              className="min-w-[120px]"
            />
          </div>

          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-muted-foreground">Category:</label>
            <Select
              options={categoryOptions}
              value={selectedFilters?.category}
              onChange={(value) => handleFilterChange('category', value)}
              placeholder="Select Category"
              className="min-w-[160px]"
            />
          </div>

          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-muted-foreground">Status:</label>
            <Select
              options={statusOptions}
              value={selectedFilters?.status}
              onChange={(value) => handleFilterChange('status', value)}
              placeholder="Select Status"
              className="min-w-[140px]"
            />
          </div>

          <Button 
            variant="outline" 
            iconName="X"
            onClick={handleClearFilters}
            className="text-xs"
          >
            Clear
          </Button>
        </div>
      </div>
      {/* Active Filters Display */}
      <div className="mt-4 flex flex-wrap gap-2">
        {Object.entries(selectedFilters || {})?.filter(([key, value]) => value && value !== 'all')?.map(([key, value]) => {
            const displayValue = key === 'timePeriod' ? value : 
              [...departmentOptions, ...categoryOptions, ...statusOptions]?.find(opt => opt?.value === value)?.label || value;
            
            return (
              <div
                key={key}
                className="bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-medium flex items-center space-x-2"
              >
                <span>{displayValue}</span>
                <Icon 
                  name="X" 
                  size={12} 
                  className="cursor-pointer hover:text-primary-dark" 
                  onClick={() => handleFilterChange(key, 'all')}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default BudgetFilters;